import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{staticClass:"custom-button",class:_vm.customClasses(),attrs:{"color":_vm.customOrDefaultColor(),"x-large":"","depressed":"","disabled":_vm.disabled,"loading":_vm.loading},on:{"click":function($event){return _vm.onClick()}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }